import { NotificationPanel } from './notification-panel';
import { usePortalOutlet } from './use-portal-outlet';

/** The notification list. Held by the frame, because the tab bar shows the unread count too. */
export function NotificationsTab() {
    const { notifications, notificationsReading, markAllRead, markOneRead } = usePortalOutlet();

    return (
        <NotificationPanel
            notifications={notifications.items}
            unreadCount={notifications.unreadCount}
            markingRead={notificationsReading}
            onMarkAllRead={markAllRead}
            onMarkRead={markOneRead}
        />
    );
}
